import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { FooterService } from '../services/footer.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: true,
    imports: []
})
export class FooterComponent {
  private sanitizer = inject(DomSanitizer);
  private footerService = inject(FooterService);

  readonly currentYear: number = new Date().getFullYear();

  get sanitizedLogoSource(): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.footerService.PARTICIPATION_BASE_64_LOGO);
  }

  get sanitizeLinkedinSource(): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.footerService.LINKEDIN_ICON_BASE_64);
  }

  get sanitizeAvanaLogoSource(): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.footerService.AVANA_CAP_LOGO_BASE_64);
  }
}
